module.exports = __webpack_public_path__ + "static/media/turnDown.ec3ca670.svg";